export default __webpack_public_path__ + "static/media/foto08.1860c5be.png";